import React from 'react';
import NotFoundPage from '../../../routes/notFound';
import ExceptionPage from '../../../routes/exception';
import { IReactAppError, ReactAppErrorType, ReactAppRedirectError } from '../../../../../../common/model/reactApp/error';
import RedirectPage from '../../../routes/redirect';

export const ErrorRenderer: React.FC<{ error: IReactAppError }> = ({ error }) => {
  let page: React.ReactNode;

  if (error.type === ReactAppErrorType.PageNotFound) {
    page = <NotFoundPage />;
  } else if (error.type === ReactAppErrorType.Redirect) {
    page = <RedirectPage error={error as ReactAppRedirectError} />;
  } else {
    page = <ExceptionPage />;
  }

  return page;
};
